import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import classNames from 'classnames/bind';

import styles from './Layout.module.scss';

const transition = {
	duration: 0.3,
	ease: [0.43, 0.13, 0.23, 0.96],
};

const pageVariants = {
	initial: { x: '5%', opacity: 0, transition },
	enter: { x: '0%', opacity: 1, transition },
	exit: { x: '-5%', opacity: 0, transition },
};

const cx = classNames.bind(styles);

function ScrollToTop() {
	React.useEffect(() => {
		const body = document.querySelector('#root');
		const elPosition = body.getBoundingClientRect().top;
		const offset = 98;
		const offsetPostion = elPosition +  window.pageYOffset - offset;

    	window.scrollTo({
			top: offsetPostion,
        	behavior: 'smooth',
    	})
	}, []);

	return null;
};


const Layout = (props) => {
	return (
		<React.Fragment>
			{props.autoScroll && <ScrollToTop /> }
			<motion.div
				className={cx(styles.pageContainer, props.additionalClass)}
				initial='initial'
				animate='enter'
				exit='exit'
				variants={pageVariants}>

				<div className={cx(styles.innerContainer, { noPadding: props.noPadding })}>
					{props.children}
				</div>
			</motion.div>
		
		</React.Fragment>
	);
};

Layout.defaultProps = {
	showHeader: true,
	autoScroll: true,
}

Layout.propTypes = {
	noPadding: PropTypes.bool,
	children: PropTypes.node.isRequired,
    additionalClass: PropTypes.string,
	showHeader: PropTypes.bool,
	autoScroll: PropTypes.bool,
};

export default Layout;
